export default {
  BASE_URL: process.env.REACT_APP_API_BASE_URL ?? 'http://localhost:3333'
};